angular.module('PinMeTo.directives').directive('autofill', [
	'$timeout',
	function ($timeout) {
		'use strict';

		var INTERVAL_MS = 500;
		return {
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				var timer;
				function startTimer() {
					timer = $timeout(function () {
						var value = element.val();
						if (value && ngModel.$viewValue !== value) {
							ngModel.$setViewValue(value);
						}
						startTimer();
					}, INTERVAL_MS);
				}
				scope.$on('$destroy', function () {
					$timeout.cancel(timer);
				});

				startTimer();
			}
		};
	}
]);
